import { useMemo } from 'react';
import dayjs from 'dayjs';

import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  dateOfService?: string;
  accounts?: OcrAccountOrderOption[];
  isAccountOrdersLoading?: boolean;
}

const useHasAvailableAccounts = ({ dateOfService, accounts, isAccountOrdersLoading }: Props) => {
  const hasAvailableAccounts = useMemo(() => {
    if (isAccountOrdersLoading || !dateOfService) {
      return true;
    }

    if (!accounts?.length) {
      return false;
    }
  
    const serviceDate = dayjs(dateOfService);

    return accounts.some((account) => {
      const start = account?.coverageDateStart;
      const end = account?.coverageDateEnd;
      if (!start && !end) return true;
      if (!start) return serviceDate.valueOf() <= dayjs(end).valueOf();
      if (!end) return serviceDate.valueOf() >= dayjs(start).valueOf();
      return serviceDate.valueOf() >= dayjs(start).valueOf() && serviceDate.valueOf() <= dayjs(end).valueOf();
    });
  }, [accounts, dateOfService, isAccountOrdersLoading]);

  return {
    hasAvailableAccounts,
  };
};

export default useHasAvailableAccounts;
